import * as z from 'zod';

import { empresaSchema } from './EmpresaSchema';
import { ProdutoSchema } from './ProdutoSchema';
import { VendedorSchema } from './VendedorSchema';

export const schema = z.object({
  vendedor: VendedorSchema,
  empresa: empresaSchema,

  planos: z.array(ProdutoSchema).optional(),
});

export type Schema = z.infer<typeof schema>;
